<div libDraggable [dragHandle]="'.imgIndividualHeader'" [dragTarget]="'.entryForm'" class="card entryForm" [ngClass]="{'activate': showIndividual}">
  <div class="card-header imgIndividualHeader">
      {{ editMode ? 'Edit' : 'Add New' }} Image Individual
      <div class="close" title="Close" (click)="close()">&times;</div>
  </div>
  <div class="card-body">
    <form name="individualEditForm" id="individualEditForm" autocomplete="off">
      <div class="card-title">
        <h5>
        <span class="individualName" *ngIf="data.firstName || data.lastName; else unknownName">{{ data.firstName }} {{ data.lastName }} </span>
        <span *ngIf="data.rank && data.rank.uid != 0 && data.rank.rankCategory">: {{ data.rank.rankDisplay }} </span>
         <span *ngIf="(data.regimentNo && data.regimentNo.uid != 0) || (data.state && data.state.uid != 0) || (data.branch && data.branch.uid != 0)"> of the </span>
        <span *ngIf="(data.regimentNo && data.regimentNo.uid != 0)">
        {{ writeOrdinalSuffix(data.regimentNo.regimentNo) }} </span>
        <span *ngIf="data.state && data.state.uid != 0">
        {{ data.state.abbreviation }} </span>
        <span *ngIf="data.branch && data.branch.uid != 0">
        {{ data.branch.branchName }} </span>
        <span>
         {{ data.companyLetters }} </span>
         <span *ngIf="data.army > 0">({{ data.army === 1 ? 'US' : 'CS' }}) </span> <!-- TODO: this should use the enum string if more UnitArmies are added -->
         <span *ngIf="data.corps">({{ writeOrdinalSuffix(data.corps) }} Corps)</span>
        </h5>
      </div>
      <div *ngIf="loaded; else pleaseWait" class="card-text">
        Name
        <div class="row">
          <input type="text" name="imgIndFirstName" class="col form-control editable focus" placeholder="First Name" autofocus id="firstNameInput" 
            [(ngModel)]="data.firstName" 
            [focusFirst]="false" maxlength="400"
            (focus)="fNameFocus$.next($any($event).target.value)"
            (click)="fNameClick$.next($any($event).target.value)"
            [autocomplete]="'off'">
            <!--
              (keydown.Tab)="ignoreTypeaheadSuggestion = true" #fNameSearcher="ngbTypeahead" (blur)="ignoreTypeaheadSuggestion = false"
              [ngbTypeahead]="nameSearch(true)"
              (selectItem)="interceptTypeaheadSelection($event)"
            -->

          <input type="text" name="imgIndLastName" class="col form-control editable" placeholder="Last Name" maxlength="400" id="lastNameInput"
          [(ngModel)]="data.lastName"
          [focusFirst]="false"
          (focus)="lNameFocus$.next($any($event).target.value)"
          (click)="lNameClick$.next($any($event).target.value)"
          [autocomplete]="'off'">
          <!--
            (keydown.Tab)="ignoreTypeaheadSuggestion = true" #lNameSearcher="ngbTypeahead" (blur)="ignoreTypeaheadSuggestion = false"
            [ngbTypeahead]="nameSearch(false)"
            (selectItem)="interceptTypeaheadSelection($event)"
          -->
        </div>
        <hr>
        <!-- <div class="row">
          <div class="col-3">
            Rank Category
          </div>
          <div class="col-1"></div>
          <div class="col-3">Rank</div>
        </div> -->
        <div class="row">
          <div class="col-3">
            <mat-form-field>
              <mat-label>Rank category</mat-label>
              <mat-select [(value)]="data?.rank.rankCategoryId" id="rankCatDropdown" [typeaheadDebounceInterval]="dropdownTypeDebounceTime" aria-placeholder="rank category" (selectionChange)="filterRanksByCat($event.value)">
                <mat-option value="-1">None</mat-option>
                <mat-option *ngFor="let rc of rankCats" [value]="rc.uid">{{ rc.rankCategory }}</mat-option>
              </mat-select>
            </mat-form-field>
            <!-- <select name="rankCatDropdown" id="rankCatDropdown" class="col form-control" aria-placeholder="rank category" [(ngModel)]="data?.rank.rankCategoryId"
              (ngModelChange)="filterRanksByCat($event)">
              <option [ngValue]="-1">Select rank category</option>
              <option *ngFor="let rc of rankCats" [ngValue]="rc.uid">{{ rc.rankCategory }}</option>
            </select> -->
          </div>
          <div class="col-1"></div>
          <div class="col-3">
            <mat-form-field>
              <mat-label>Rank</mat-label>
              <mat-select [(value)]="data.rankId" aria-placeholder="rank for individual"  [typeaheadDebounceInterval]="dropdownTypeDebounceTime" id="rankDropdown" (selectionChange)="updateRank($event.value)">
                <mat-option value="-1">None</mat-option>
                <mat-option *ngFor="let r of ranksFiltered" [value]="r.uid">{{ r.rankName }}</mat-option>
              </mat-select>
            </mat-form-field>
            <!-- <select name="rankDropdown" aria-placeholder="rank for individual" id="rankDropdown" class="col form-control" (ngModelChange)="updateRank($event)"
              [(ngModel)]="data.rankId">
              <option [ngValue]="-1">None</option>
              <option *ngFor="let r of ranksFiltered" [ngValue]="r.uid">{{ r.rankName }}</option>
            </select> -->
          </div>
        </div>
        <br *ngIf="typeOfImageId !== ImageTypes['Letters & Diaries']">
        <label *ngIf="typeOfImageId !== ImageTypes['Letters & Diaries']" style="font-weight: bold;" class="form-check-label" style="vertical-align: sub; max-width: fit-content;" for="currentRank">Current Rank in Photo? </label>
        <input *ngIf="typeOfImageId !== ImageTypes['Letters & Diaries']" style="margin: 5px; height: 25px; width: 25px;" type="checkbox" name="currentRank" id="currentRank"
          class="form-check-input" [(ngModel)]="data.currentRankInPhoto">
        <hr *ngIf="typeOfImageId === ImageTypes['Letters & Diaries']">
        <label *ngIf="typeOfImageId === ImageTypes['Letters & Diaries']" style="font-weight: bold;" class="form-check-label" style="vertical-align: sub;" for="author" title="Indicates whether this individual is the author of the current item.">Author? </label>
        <input *ngIf="typeOfImageId === ImageTypes['Letters & Diaries']" style="margin: 5px; height: 25px; width: 25px;" type="checkbox" name="author" id="author"
          class="form-check-input" [(ngModel)]="data.author">
        <hr>
        Unit
        <app-unit-picker #unitPicker [regiments]="regiments" [states]="states" [branches]="branches" [coLetters]="coLetters"
          (unitSelected)="updateUnit($event)"></app-unit-picker>
        <hr>
        Notes
        <br>
        <textarea name="notes" [(ngModel)]="data.notes"></textarea>
      </div>

      <app-slant-button btnColor="green" [tooltip]="'Set your changes to the image record'" class="me-1" [disabled]="!loaded" submitMode="true" (click)="saveButton()" btnIconClass="fa-check-circle">Okay</app-slant-button>

      <app-slant-button btnColor="gray" [tooltip]="'Clear all fields for this individual'" class="me-1" [disabled]="!loaded" (click)="reset()" btnIconClass="fa-backspace">Clear</app-slant-button>

      <app-slant-button btnColor="yellow" [tooltip]="'Cancel your changes and close the form'" class="me-1" (click)="close()" btnIconClass="fa-ban">Cancel</app-slant-button>

      <app-slant-button *ngIf="data.uid != 0" [tooltip]="'Remove this individual from the image record'" [disabled]="!loaded" btnColor="red" (click)="deleteButton()" btnIconClass="fa-trash">Delete Individual</app-slant-button>
    </form>
  </div>
</div>
<ng-template #pleaseWait>
  Loading data, please wait...
  <br><br>
</ng-template>
<ng-template #unknownName>
  <span class="individualName text-muted">(Name unknown)</span>
</ng-template>
